import * as Backbone from "backbone";
import _ from 'lodash';

export const AddView = Backbone.View.extend({
	events: {
		click: 'triggerAdd'
	},
	initialize: function (options) {
		this.label = options.label;
		this.callback = options.callback;
		this.render();
	},
	triggerAdd: function () {
		this.callback();
	},
	template: _.template('<div class="AddView MenuButton MenuItemPassive">\n\t<div class="MenuIcon MenuInline"><i class="fa fa-plus-circle"></i></div>\n\t<div class="MenuLabel MenuInline"><%= v.label %></div>\n</div>'),
	render: function () {
		this.$el.html(this.template({
			v: {
				label: this.label
			}
		}));
	}
});